export default __webpack_public_path__ + "static/media/hmm.52cf9786.svg";